import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumbs } from "@air/component-breadcrumbs";
import { useSelector } from "react-redux";
import { AncestorImageContainer } from "~/components/AncestorImageContainer";
import { centralizedClipBoardInfoSelector } from "~/store/centralizedClip/selectors";
export const AssetLocationBreadcrumbs = ()=>{
    var _current_ancestors;
    const { current } = useSelector(centralizedClipBoardInfoSelector);
    if (!current || !current.library || !((_current_ancestors = current.ancestors) === null || _current_ancestors === void 0 ? void 0 : _current_ancestors.length)) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center text-grey-11",
        children: [
            "in",
            /*#__PURE__*/ _jsx(Breadcrumbs, {
                className: "ml-2 truncate text-grey-11",
                isCompact: true,
                items: [
                    {
                        className: "text-inherit",
                        id: current.library.id,
                        prefix: /*#__PURE__*/ _jsx(AncestorImageContainer, {
                            backgroundColor: current.library.color.backgroundHex,
                            children: /*#__PURE__*/ _jsx("p", {
                                className: "text-14",
                                children: current.library.icon
                            })
                        }),
                        label: current.library.title,
                        type: "item"
                    },
                    ...current.ancestors.map((ancestor)=>({
                            className: "text-inherit",
                            id: ancestor.id,
                            label: ancestor.title,
                            type: "item"
                        })),
                    {
                        className: "text-inherit",
                        id: current.id,
                        label: current.title,
                        type: "item"
                    }
                ]
            })
        ]
    });
};
